enum ManifestError {
    NO_SUCCESSFUL_MANIFEST_REQUESTS_MADE = 'No successful manifest requests made',
    NO_SEGMENTS_FOUND_IN_MANIFEST = 'No segments found in manifest',
    MANIFEST_REQUEST_FAILED = 'Manifest request failed',
    MALFORMED_MANIFEST = 'Manifest could not be parsed'
}

export default ManifestError;